import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';
import { sortByString } from 'utilities/dataSorters';

export const useGetMasters = () => {
  const mastersService = useServices().mastersService;
  return useQuery({
    queryKey: ['masters'],
    queryFn: async () => {
      const response = await mastersService.getMasters();
      return sortByString(response, 'fullName', 'ASCENDING');
    },
    refetchOnWindowFocus: false,
  });
};
